export default __webpack_public_path__ + "9207e8c1afca3af57f43e2a06024f85d.svg";